import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type PriceCategoryStatus,
  patchPricesCategoriesPriceCategoryIDStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PRICE_CATEGORIES_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdatePriceCategoryStatusParams {
  priceCategoryID: string;
  status: PriceCategoryStatus;
}

export function useUpdatePriceCategoryStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ priceCategoryID, status }: UpdatePriceCategoryStatusParams) =>
      patchPricesCategoriesPriceCategoryIDStatus({ status }, priceCategoryID),
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PRICE_CATEGORIES_QUERY_KEYS.all,
      });
    },
  });
}
